import { FetchApiResponse } from "redux/types";

export enum CustomerDumpReportReduxTypes {
    CUSTOMER_DUMP_REPORT="@@report/CUSTOMER_DUMP_REPORT",
    CUSTOMER_DUMP_REPORT_SUCCESS="@@report/CUSTOMER_DUMP_REPORT_SUCCESS",
    CUSTOMER_DUMP_REPORT_ERROR="@@report/CUSTOMER_DUMP_REPORT_ERROR"
}

export type CustomerDumpReportActionDispatch = {
    type: CustomerDumpReportReduxTypes.CUSTOMER_DUMP_REPORT;
    payload: any;
}

export type CustomerDumpReportReducerDispatch = {
    type:
        | CustomerDumpReportReduxTypes.CUSTOMER_DUMP_REPORT
        | CustomerDumpReportReduxTypes.CUSTOMER_DUMP_REPORT_SUCCESS
        | CustomerDumpReportReduxTypes.CUSTOMER_DUMP_REPORT_ERROR;

    payload: {
        data?: FetchApiResponse<CustomerDumpReport>;
        error?: string;
    }
}

export type CustomerDumpReport = {
    id: string,
    financierId: string,
    userId: string,
    type: string,
    status: number,
    updatedOn: string,
    createdOn: string
}

export type CreateCustomerDumpReportRequest = {
    payload: {
        customerExternalId?: string
    },
    type: string
}

export type CreateCustomerDumpReduxState = {
    loading?: boolean,
    data?: {},
    error?: string | null;
}